import * as braintree from 'braintree-web';
import type { PaypalButtonStyle } from '@hotjar/checkout/src/@types/paypal';

import { setupClient } from './common';

interface SetupPaypalConfig {
  accountId: number | null;
  paypalButtonId: string;
  onPaypalLogin(payload: paypal.AuthorizationResponse): void;
  style: PaypalButtonStyle;
}

/**
 * Setup the Paypal integration for Braintree.
 */
export async function setupPaypal({
  accountId,
  paypalButtonId,
  onPaypalLogin,
  style = {},
}: SetupPaypalConfig): Promise<braintree.PayPalCheckout> {
  const client = await setupClient(accountId as number);

  const instance = await braintree.paypalCheckout.create({ client });

  const clientId = global.getBasedOnEnvironment<string>({
    prod: 'AUmGf8BjHrWJYUaxqHh_tq_Ej37bl9wytRNu0EN0xCmsSeJcMZSkOLK1b0VdwHyIccWoA3SJmWhnjq-M',
    default: 'AbMBrqf1wRxCQ3EKVfOoW7pNVyE51vzWeBWrvswjYukPJVRuQknWxLlG6bIKcKkwDIyWWAdg9g_JibmZ',
  });

  await instance.loadPayPalSDK({ vault: true, 'client-id': clientId });

  await window.paypal
    .Buttons({
      createBillingAgreement: () =>
        instance.createPayment({
          flow: 'vault' as paypal.FlowType.Vault,
        }),
      onApprove: (data) => instance.tokenizePayment(data).then(onPaypalLogin),
      fundingSource: 'paypal',
      style,
    })
    .render(`#${paypalButtonId}`);

  return instance;
}
